var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#DBDBDB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_4832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3926 16.3206L16.6161 23.097C15.3139 24.3993 13.2043 24.3993 11.9021 23.097C10.5998 21.7948 10.5998 19.6852 11.9021 18.383L19.2678 11.0173C20.0809 10.2041 21.4009 10.2041 22.214 11.0173C23.0272 11.8304 23.0272 13.1504 22.214 13.9636L16.0269 20.1507C15.7028 20.4748 15.1724 20.4748 14.8484 20.1507C14.5243 19.8266 14.5243 19.2963 14.8483 18.9722L20.4463 13.3743L19.5624 12.4904L13.9645 18.0883C13.1513 18.9015 13.1513 20.2214 13.9645 21.0346C14.7776 21.8478 16.0976 21.8478 16.9107 21.0346L23.0979 14.8474C24.4002 13.5452 24.4002 11.4356 23.0979 10.1334C21.7957 8.83113 19.6861 8.83113 18.3839 10.1334L11.0182 17.4991C9.22685 19.2904 9.22685 22.1896 11.0182 23.9809C12.8095 25.7722 15.7087 25.7722 17.5 23.9809L24.2764 17.2045L23.3926 16.3206Z",
    fill: "#6B6B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_4832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(17.5 3.35742) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d3bb218326da0602f421806fe6415bd4.svg";
export { ForwardRef as ReactComponent };